<script lang="ts">
	import { trackAction } from '$lib/tracking';
	import { getContext } from 'svelte';
	import type { Writable } from 'svelte/store';

	export let pageNumber: number;
	export let ariaLabel: string = '';

	const { currentPage, setCurrentPage } = getContext<{
		currentPage: Writable<number>;
		setCurrentPage: (page: number) => void;
	}>('pagination');

	function handleClick(pageNumber: number) {
		trackAction('content', 'button', `Seite ${pageNumber}`);
		setCurrentPage(pageNumber);
	}
</script>

<button
	type="button"
	class="border-gray-2 border hover:border-magenta hover:text-magenta hover:bg-gray-11 rounded w-8 h-8 md:w-13.5 md:h-10.5"
	class:cursor-default={pageNumber === $currentPage}
	class:!text-white={pageNumber === $currentPage}
	class:!bg-magenta={pageNumber === $currentPage}
	class:!border-magenta={pageNumber === $currentPage}
	on:click={() => handleClick(pageNumber)}
	{...ariaLabel ? { 'aria-label': ariaLabel } : {}}
>
	{pageNumber}
</button>
